// The Wiggle Toy — theme JS (v3.8: Buy Now direct checkout + focus pass — static hero, 3 benefits, no family section, scroll car desktop-only)
(function () {
  var offEl = document.getElementById('bundle-off-cents');
  var BUNDLE_OFF = offEl ? parseInt(offEl.value, 10) : 4900; // mirrors the automatic discount (theme setting)
  var fmt = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Buy box state ---------- */
  var radios = document.querySelectorAll('.swatch input[name="id"]');
  var bundleOn = false;

  function currentRadio() {
    return document.querySelector('.swatch input[name="id"]:checked') || radios[0];
  }
  function secondRadio() {
    var s = document.querySelector('input[name="second-id"]:checked');
    if (s) return s;
    // default second color: first variant that differs from the primary
    var cur = currentRadio();
    var all = document.querySelectorAll('input[name="second-id"]');
    for (var i = 0; i < all.length; i++) {
      if (!cur || all[i].dataset.title !== cur.dataset.title) { all[i].checked = true; return all[i]; }
    }
    if (all[0]) { all[0].checked = true; return all[0]; }
    return null;
  }
  function unitCents() {
    var r = currentRadio();
    return r ? parseInt(r.dataset.cents, 10) : 21900;
  }
  function totalCents() {
    return bundleOn ? unitCents() * 2 - BUNDLE_OFF : unitCents();
  }

  function sync() {
    var r = currentRadio();
    if (!r) return;
    var img = document.getElementById('buy-image');
    var tag = document.getElementById('buy-media-tag');
    var price = document.getElementById('buy-price');
    var compare = document.getElementById('buy-compare');
    var badge = document.getElementById('save-badge');
    var atcPrice = document.getElementById('atc-price');
    var selected = document.getElementById('buy-selected');
    var sbLabel = document.getElementById('sb-label');
    var bundleTotal = document.getElementById('bundle-total');
    var secondSel = document.getElementById('second-selected');

    if (img && r.dataset.image) img.src = r.dataset.image;
    if (tag) tag.textContent = r.dataset.title;
    if (selected) selected.textContent = r.dataset.title;
    if (bundleTotal) bundleTotal.textContent = fmt(unitCents() * 2 - BUNDLE_OFF);
    var bc1 = document.getElementById('bc1-price');
    if (bc1) bc1.textContent = fmt(unitCents());
    if (price) price.textContent = fmt(totalCents());
    if (compare) { compare.textContent = fmt(unitCents() * 2); compare.hidden = !bundleOn; }
    if (badge) badge.hidden = !bundleOn;
    var atc = document.getElementById('atc-btn');
    if (atc && !atc.classList.contains('added')) {
      atc.innerHTML = (bundleOn ? 'Buy 2 Now — ' : 'Buy Now — ') +
        '<span id="atc-price">' + fmt(totalCents()) + '</span>';
    }
    var s = document.querySelector('input[name="second-id"]:checked');
    if (secondSel && s) secondSel.textContent = s.dataset.title;
    if (sbLabel) {
      sbLabel.innerHTML = 'Wiggle Car' + (bundleOn ? ' ×2' : '') + ' · ' + r.dataset.title +
        '<small>' + fmt(totalCents()) + ' · Free 3–6 day U.S. shipping</small>';
    }
  }
  radios.forEach(function (r) { r.addEventListener('change', sync); });
  document.querySelectorAll('input[name="second-id"]').forEach(function (r) {
    r.addEventListener('change', sync);
  });

  var secondRow = document.getElementById('second-color');
  document.querySelectorAll('input[name="bundle"]').forEach(function (b) {
    b.addEventListener('change', function () {
      bundleOn = b.value === '2';
      if (secondRow) { secondRow.hidden = !bundleOn; if (bundleOn) secondRadio(); }
      var c1 = document.getElementById('color1-h');
      if (c1) c1.textContent = bundleOn ? 'Car #1 color' : 'Choose their color';
      sync();
    });
  });


  /* ---------- Buy Now: clear cart → add selection → straight to /checkout ----------
     One-product store: no cart page. Clearing first means a repeat click or an
     earlier abandoned add never stacks into a surprise double order. The dynamic
     payment button (Shop Pay / PayPal) keeps its own native express flow. */
  function addToCart(btn) {
    var r = currentRadio();
    if (!r) return;
    var items = [];
    if (bundleOn) {
      var s = secondRadio();
      if (s && s.value !== r.value) {
        items.push({ id: parseInt(r.value, 10), quantity: 1 });
        items.push({ id: parseInt(s.value, 10), quantity: 1 });
      } else {
        items.push({ id: parseInt(r.value, 10), quantity: 2 });
      }
    } else {
      items.push({ id: parseInt(r.value, 10), quantity: 1 });
    }
    // Cart permalink: /cart/<variant>:<qty>[,<variant>:<qty>] builds the
    // checkout directly from the URL — no dependency on the cart session or
    // cookies, so it can't bounce back to the homepage with an empty cart.
    var permalink = '/cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
    if (btn) { btn.disabled = true; btn.innerHTML = 'Heading to checkout ✓'; btn.classList.add('added'); }
    // Fire the add-to-cart in the background so the Meta ATC event still
    // tracks, but don't make navigation wait on it.
    try {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    } catch (err) {}
    setTimeout(function () { window.location.href = permalink; }, 350);
  }
  var buyForm = document.getElementById('buy-form');
  if (buyForm && window.fetch) {
    buyForm.addEventListener('submit', function (e) {
      // Let Shopify's dynamic payment button handle its own flow.
      if (e.submitter && e.submitter.closest && e.submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      addToCart(document.getElementById('atc-btn'));
    });
  }

  /* ---------- Color strip → buy box sync (ported event-bus behavior) ---------- */
  document.querySelectorAll('.color-card').forEach(function (cardEl) {
    cardEl.addEventListener('click', function () {
      var t = cardEl.dataset.title;
      radios.forEach(function (r) { if (r.dataset.title === t) { r.checked = true; } });
      sync();
    });
  });

  /* ---------- Sticky bar: shows after buy box, hides over FAQ/final CTA ---------- */
  var buy = document.getElementById('buy');
  var bar = document.getElementById('stickybar');
  if (buy && bar) {
    var sbBtn = document.getElementById('sb-add');
    if (sbBtn) sbBtn.addEventListener('click', function () { addToCart(sbBtn); });
    var blockers = [document.getElementById('faq'), document.querySelector('.final'), document.querySelector('.site-footer')].filter(Boolean);
    var onScroll = function () {
      var past = buy.getBoundingClientRect().bottom < 0;
      var blocked = blockers.some(function (b) {
        var rect = b.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });
      var show = past && !blocked;
      bar.classList.toggle('show', show);
      document.body.classList.toggle('has-sticky', show);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Scroll road (faithful port of the prototype's ScrollRoad) ----------
     The road path is generated from the REAL positions of [data-road-stop]
     sections (alternating page sides), and the car is eased along it from
     scroll progress with tangent rotation. Desktop: car below content;
     mobile: above content. Reduced motion: static road, no car. */
  (function scrollRoad() {
    var wrap = document.getElementById('road-wrap');
    var svg = document.getElementById('road-svg');
    var bed = document.getElementById('road-bed');
    var dash = document.getElementById('road-dash');
    var carLayer = document.getElementById('road-car-layer');
    var car = document.getElementById('road-car2');
    if (!wrap || !svg || !bed || !dash) return;
    // v3.8 (Slav, Sep 8): the scroll-following Wiggle Toy is DESKTOP-ONLY.
    // CSS hides road + car under 768px; the tick below also skips work there.
    // Reduced motion removes the moving car everywhere.
    if (reduced && carLayer) carLayer.remove();

    function build() {
      var w = wrap.clientWidth;
      var h = wrap.scrollHeight;
      var stops = Array.prototype.slice.call(wrap.querySelectorAll('[data-road-stop]'));
      if (!w || !h || stops.length < 2) return false;
      // Mobile: hug the outside edges so the route never runs through
      // centered copy or purchase controls. Desktop: current positioning.
      var narrow = w < 768;
      var outer = narrow ? 0.92 : 0.86;
      var pts = stops.map(function (el, i) {
        return { x: w * (i % 2 === 0 ? outer : 1 - outer), y: el.offsetTop + el.offsetHeight * 0.5 };
      });
      var d = 'M ' + (w * 0.5).toFixed(1) + ' 0';
      d += ' C ' + (w * 0.5).toFixed(1) + ' ' + (pts[0].y * 0.55).toFixed(1) + ', ' + pts[0].x.toFixed(1) + ' ' + (pts[0].y * 0.55).toFixed(1) + ', ' + pts[0].x.toFixed(1) + ' ' + pts[0].y.toFixed(1);
      for (var i = 1; i < pts.length; i++) {
        var a = pts[i - 1], b = pts[i];
        var my = ((a.y + b.y) / 2).toFixed(1);
        d += ' C ' + a.x.toFixed(1) + ' ' + my + ', ' + b.x.toFixed(1) + ' ' + my + ', ' + b.x.toFixed(1) + ' ' + b.y.toFixed(1);
      }
      var last = pts[pts.length - 1];
      var endY = Math.min(h - 40, last.y + (h - last.y) * 0.8);
      d += ' C ' + last.x.toFixed(1) + ' ' + ((last.y + endY) / 2).toFixed(1) + ', ' + (w * 0.5).toFixed(1) + ' ' + ((last.y + endY) / 2).toFixed(1) + ', ' + (w * 0.5).toFixed(1) + ' ' + endY.toFixed(1);
      svg.setAttribute('width', w);
      svg.setAttribute('height', h);
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      bed.setAttribute('d', d);
      dash.setAttribute('d', d);
      return true;
    }

    var built = build();
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { built = build(); }).observe(wrap);
    }

    if (reduced || !car) return;
    var current = -1;
    function tick() {
      var mobile = window.innerWidth < 768;
      if (mobile) { current = -1; requestAnimationFrame(tick); return; } // hidden on mobile
      if (built) {
        var rect = wrap.getBoundingClientRect();
        var vh = window.innerHeight;
        var CW = 78, CH = 78;
        var driven = vh * 0.45 - rect.top;
        var target = Math.min(1, Math.max(0, driven / Math.max(1, rect.height - vh * 0.4)));
        if (current < 0) current = target;
        current += (target - current) * 0.09; // easing — the car "chases" the scroll
        var total = dash.getTotalLength();
        var len = current * total;
        var p = dash.getPointAtLength(len);
        var ahead = dash.getPointAtLength(Math.min(total, len + 3));
        var angle = Math.atan2(ahead.y - p.y, ahead.x - p.x) * 180 / Math.PI;
        car.style.transform = 'translate(' + (p.x - CW / 2).toFixed(1) + 'px,' + (p.y - CH / 2).toFixed(1) + 'px) rotate(' + angle.toFixed(1) + 'deg)';
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  })();

  /* ---------- Reusable policy drawer (Shipping & Returns / Quality Protection) ---------- */
  (function policyModal() {
    var modal = document.getElementById('pmodal');
    var body = document.getElementById('pmodal-body');
    if (!modal || !body) return;
    var panel = modal.querySelector('.pmodal-panel');
    var lastFocus = null;

    function open(kind, trigger) {
      var tpl = document.getElementById('tpl-' + kind);
      if (!tpl) return;
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      lastFocus = trigger || document.activeElement;
      modal.hidden = false;
      document.body.classList.add('pmodal-open');
      panel.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.classList.remove('pmodal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.querySelectorAll('[data-pmodal]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault(); // falls back to the policy page without JS
        open(a.dataset.pmodal, a);
      });
    });
    modal.querySelectorAll('[data-pmodal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') { // trap focus inside the panel
        var f = panel.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  /* ---------- Final CTA skid: fires once at 35% visibility ---------- */
  var finalCta = document.getElementById('final-cta');
  if (finalCta && 'IntersectionObserver' in window) {
    var skidObs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        finalCta.classList.add('skid-go');
        skidObs.disconnect();
      }
    }, { threshold: 0.35 });
    skidObs.observe(finalCta);
  } else if (finalCta) {
    finalCta.classList.add('skid-go');
  }

  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  sync();
})();
